import React from "react";
import Header from "./components/Header";
import About from "./components/About";

const Home = () => {
  return (
    <>
      <div className="d-flex justify-content-center">
        <div className="col-xl-3 col-lg-2 col-md-1 col-sm-1 col-0 d-flex flex-column"></div>
        <div className="col-xl-6 col-lg-8 col-md-10 col-sm-10 col-12 d-flex flex-column shadow">
          <Header />
          <About />
        </div>
        <div className="col-xl-3 col-lg-2 col-md-1 col-sm-1 col-0 d-flex flex-column"></div>
      </div>
    </>
  );
};

export default Home;
